import React, { Component } from "react";
import "./CarFormConfirm.css";

import store from "../../store";
import { Route, Link, BrowserRouter as Router } from "react-router-dom";
import Grid from "@material-ui/core/Grid";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import CarFormDetail from "../CarFormDetail/CarFormDetail";

class CarFormConfirm extends Component {
  constructor(props) {
    super(props);
  }

  handleChange = event => {};

  componentDidMount() {}

  render() {
    return (
      <div>
        <Header />
        <div className="GridConfirm">
          <Grid container spacing={5} xs={12} sm={12}>
            <Grid container spacing={3} xs={12} sm={7}>
              <div className="ConfirmText">
                <div className="ConfirmTitle">¡Felicitaciones! </div>
                <div className="ConfirmSubTitle">
                  La reserva de tu <b>Corolla </b> fue un éxito.
                </div>
                <br />
                <div className="ConfirmTextContent">
                  Enviaremos un mail a tu casilla con los datos de la reserva y
                  te asesoraremos para continuar. <br />
                  <br />
                  Pronto estarás disfrutando de tu Okm.
                </div>
              </div>
            </Grid>
            <Grid
              container
              spacing={3}
              xs={12}
              sm={4}
              style={{ marginLeft: "20px" }}
            >
              <Grid item xs={12} sm={12}>
                <div className="CarFormBox CarFormBoxConfirm">
                  <div className="CarFormTitle2">YA RESERVASTE TU:</div>

                  <div
                    style={{
                      width: "100%",
                      display: "flex",
                      marginTop: "20px"
                    }}
                  >
                    <div
                      style={{
                        width: "40%"
                      }}
                    >
                      <div
                        style={{
                          fontFamily: "ToyotaBold",
                          fontSize: "1.5rem",
                          marginTop: "10px"
                        }}
                      >
                        COROLLA
                      </div>
                      <div
                        style={{
                          fontFamily: "ToyotaRegular",
                          fontSize: "1.2rem"
                        }}
                      >
                        1.8 Se-g Cvt
                      </div>
                    </div>
                    <div className="FormCarImgDiv">
                      <img
                        src="/img/cars/corolla-gray-big.png"
                        className="FormCarImg"
                      />
                    </div>
                  </div>
                </div>
              </Grid>
            </Grid>
          </Grid>
        </div>
        <Footer />
      </div>
    );
  }
}

export default CarFormConfirm;
